import * as React from 'react';
import { TabItem } from './TabItem';

interface TabGroupProps {
  options: string[];
  labels: string[];
  activeOption?: string;
  className?: string;
  isSmall?: boolean;
  onChange: (value: string) => void;
}

export const TabGroup = ({
  options,
  activeOption,
  className,
  labels,
  isSmall,
  onChange,
}: TabGroupProps): JSX.Element => {
  return (
    <div className={className} role="tablist" aria-label="Sort Notifications">
      {options.map((option, i) => (
        <TabItem
          key={i}
          isActive={activeOption === option}
          aria-selected={activeOption === option}
          onClick={() => onChange(option)}
          isSmall={isSmall}
          role="tab"
        >
          {labels[i]}
        </TabItem>
      ))}
    </div>
  );
};

export interface TabOptions<T> {
  label: string;
  id: T;
  onSelect: (id: T) => void;
}

interface SimpleTabGroupProps<T> {
  tabs: TabOptions<T>[];
  active: T;
  className?: string;
  isSmall?: boolean;
}

export const SimpleTabGroup = <T,>({
  tabs,
  className,
  active,
  isSmall,
}: SimpleTabGroupProps<T>): JSX.Element => {
  return (
    <div className={className} role="tablist">
      {tabs.map((tab, i) => (
        <TabItem
          key={i}
          isActive={active === tab.id}
          aria-selcted={active === tab.id}
          onClick={() => tab.onSelect(tab.id)}
          isSmall={isSmall}
          role="tab"
        >
          {tab.label}
        </TabItem>
      ))}
    </div>
  );
};
